<template id="Cadastro">
  <v-ons-page id="CadastroPage">
    <v-ons-row style="align-itens: center; width: 80%; margin: auto">
      <v-ons-col style="max-width: 480px; margin: 0 auto; margin-top: 5%;">
        <h3 class="entrar">CADASTRO</h3>
        <h3 class="textoCPF" style="text-transform: none">
          Insira seus dados para continuar
        </h3>

        <v-ons-input
          type="email"
          style="background: #fff"
          placeholder="email@dominio.com.br*"
          float
          v-model="u.dsEmail"
          required
        ></v-ons-input>
        <v-ons-input
          placeholder="VOUCHER*"
          type="text"
          float
          v-model="u.dsVoucher"
          required
        ></v-ons-input>
        <v-ons-input
          placeholder="Senha*"
          type="password"
          float
          v-model="u.dsSenha"
          required
        ></v-ons-input>
        <v-ons-input
          placeholder="Confirmar a Senha*"
          type="password"
          float
          v-model="u.dsConfirmaSenha"
          required
        ></v-ons-input>

        <v-ons-list
          style="
            display: inline-block;
            background: transparent;
            margin-top: 10px;
            max-width: 50% !important;
            margin: 10px auto;
          "
        >
          <label class="left">
            <v-ons-checkbox
              :input-id="'checkbox-0'"
              value="0"
              v-model="checkedColors"
            ></v-ons-checkbox>
          </label>
          <label
            class="center book"
            style="color: #fff; margin-left: 10px; text-transform: none"
            :for="'checkbox-0'"
          >
            Aceito os
            <a target="_blank" href="https://qrservice.com.br/termos-de-uso">
              termos de uso</a
            >
            *
          </label>
        </v-ons-list>
        <p style="text-align: center; text-transform: none">
          * Campos obrigatórios
        </p>
      </v-ons-col>
    </v-ons-row>

    <v-row class="d-flex justify-center">
      <v-ons-button
        @click="makeCadastro()"
        class="botao"
        v-bind:disabled="btnDisable"
      >
        <img
          width="28"
          style="margin-top: 4px"
          v-show="btnDisable"
          src="../assets/img/loading.svg"
        />
        <span v-show="!btnDisable">Concluir</span>
      </v-ons-button>
    </v-row>

    <v-row class="d-flex justify-center" style="margin-top: 25px;">
      <v-ons-button @click="back()" style="background-color: gray">
        <span style="text-transform: none">Cancelar</span>
      </v-ons-button>
    </v-row>
  </v-ons-page>
</template>
<style>
#CadastroPage .page__background {
  background-color: #5b5b5b;
  background-image: url('../assets/img/Bg_QR.png');
  background-size: cover; 
  background-position: right;
}
#CadastroPage ons-select {
  margin: 0 5px 10px 5px;
  max-width: 33%;
}
#CadastroPage a {
  color: #fff;
  margin-left: 5px;
}
#CadastroPage ons-input {
  background-color: #fff;
  display: inline-block;
  position: relative;
  width: 86%;
  margin-left: 30px;
  margin-right: 30px;
  margin-bottom: 10px;
  padding: 3px;
  border-radius: 5px;
}
.left {
  float: left;
}
ons-input {
  width: 50%;
}
</style>
<script>
export default {
  name: "Cadastro",
  key: "Cadastro",
  data() {
    return {
      u: { dsVoucher: "", dsConfirmaSenha: "", dsEmail: "", dsSenha: "" },
      checkedColors: [],
      btnDisable: false,
      // dtSel:{},
      // dt: {
      //   dias: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31],
      //   meses: ["Janeiro", "Fevereiro" ,"Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
      //   anos: []
      // }
    };
  },
  created() {
    // var dt = new Date();
    // var year = dt.getFullYear();
    // for (var x=year; x>1900;--x) {
    //   this.dt.anos.push(x);
    // }
  },
  props: ["pageStack"],

  methods: {
    getAge(birthDate) {
      return Math.floor(
        (new Date() - new Date(birthDate).getTime()) / 3.15576e10
      );
    },
    zeroPad(num, places) {
      if (num != undefined) {
        var zero = places - num.toString().length + 1;
        return Array(+(zero > 0 && zero)).join("0") + num;
      } else {
        return 0;
      }
    },
    makeCadastro() {
      this.btnDisable = true;
      // var strDia = this.zeroPad(this.dtSel.dia,2)
      // var strMes = this.zeroPad(this.dt.meses.indexOf(this.dtSel.mes)+1,2);
      // this.u.strDtNascimento = this.dtSel.ano +"-"+ strMes+"-"+  strDia
      var error = "";
      //var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      //var re = "/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$";

      if (!re.test(this.u.dsEmail)) {
        error += "Por favor insira um EMAIL válido.<br>";
      }
      if (this.u.dsSenha.length < 3) {
        error += "Por favor insira uma senha maior de 3 digitos.<br>";
      }
      if (this.u.dsSenha != this.u.dsConfirmaSenha) {
        error += "A confirmação da senha deve ser igual a senha.<br>";
      }
      if (this.checkedColors.length < 1) {
        error +=
          "Você precisa aceitar os termos de uso e a politica de privacidade.<br>";
      }
      if (error != "") {
        this.$ons.notification.toast(error, {
          timeout: 1000,
          animation: "ascend",
        });
        this.btnDisable = false;
      } else {
        this.u.dsEmail = this.u.dsEmail.toLowerCase();

        fetch(this.$menu_uri + "/cadastrar", {
          method: "OPTIONS",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(this.u),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.idEstab > 0) {
              // this.$ons.notification.toast("Cadastro realizado com sucesso, realize o login na proxima pagina! ", { timeout: 1000, animation: 'ascend' });
              this.$ons.notification.toast("Seu cadastro foi realizado com sucesso.", {
                timeout: 3000,
                animation: "ascend",
              });
              // this.$emit("pop");
              this.$router.push('/');

            } else {
              this.$router.push('/');
              this.$ons.notification.toast("Voucher inválido.", {
                timeout: 3000,
                animation: "ascend",
              });
              this.btnDisable = false;
            }
          })
          .catch((error) => {
            this.$ons.notification.toast(
              "Erro ao realizar cadastro, por favor tente novamente! ",
              { timeout: 1000, animation: "ascend" }
            );
            localStorage.setItem("fetchErr", error);
            this.btnDisable = false;
          });
      }
    },
    back() {
      this.$router.push("/");
    },
  },
};
</script>